module.exports = __webpack_public_path__ + "static/media/gorilla-erp-website-design-screen.3e2fe57f.jpg";